import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {AuthUtility} from "../common/AuthUtility";
import {Constants} from "../common/Constants";

let settingsSubSidebarLinks = [
    {label: "Scopes", pathSegment: "activity-scopes"},
    {label: "Materials", pathSegment: "activity-materials"},
];

export let SettingsFrame = function () {
    if (!AuthUtility.userHasEnforcedPermissions([Constants.permissionNames.activityScopeUpdate])) return null;
    let location = useLocation();
    let navigate = useNavigate();
    let materialsSelected = location.pathname.includes("activity-materials");

    return (
        <div className="settings-frame">
            <div className="settings-frame-panel">
                <div className="settings-sub-sidebar">
                    <div className="settings-sub-sidebar-links">
                        {
                            settingsSubSidebarLinks.map(function (settingsSubSidebarLink) {
                                let selected = settingsSubSidebarLink.pathSegment === "activity-materials" ? materialsSelected : !materialsSelected;
                                return (
                                    <div
                                        key={settingsSubSidebarLink.pathSegment}
                                        className={`settings-sub-sidebar-link ${selected ? "selected" : ""}`}
                                        onClick={() => navigate(`/${Constants.routes.settings.pathSegment}/${settingsSubSidebarLink.pathSegment}`)}
                                    >
                                        {settingsSubSidebarLink.label}
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
                <div className="settings-content-panel">
                    <Outlet/>
                </div>
            </div>
        </div>
    );
};
